import { lazy, Suspense } from 'react';
import * as animations from '~/static/animations';
import type { LottiePlayerProps } from './LottiePlayer.types';

const Lottie = lazy(() => import('react-lottie-player'));

export const LottiePlayer = ({
  animationName = 'gears',
  width = '200px',
  height = '200px',
  className,
  ...props
}: LottiePlayerProps) => {
  const animationJSON = animations[animationName as keyof typeof animations];

  if (!animationJSON) {
    throw new Error(`Animation "${animationName}" not found`);
  }

  return (
    <Suspense fallback={<div style={{ height, width }} />}>
      <Lottie
        animationData={animationJSON}
        className={className}
        data-testid="lottie-player"
        loop
        play
        style={{ height, width }}
        {...props}
      />
    </Suspense>
  );
};
